import { render, staticRenderFns } from "./PublicTtemDiv.vue?vue&type=template&id=2dc0185f&scoped=true"
import script from "./PublicTtemDiv.vue?vue&type=script&lang=js"
export * from "./PublicTtemDiv.vue?vue&type=script&lang=js"
import style0 from "./PublicTtemDiv.vue?vue&type=style&index=0&id=2dc0185f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc0185f",
  null
  
)

export default component.exports